import { render, staticRenderFns } from "./ImageGrid.vue?vue&type=template&id=6f479244&scoped=true&lang=pug"
import script from "./ImageGrid.vue?vue&type=script&lang=js"
export * from "./ImageGrid.vue?vue&type=script&lang=js"
import style0 from "./ImageGrid.vue?vue&type=style&index=0&id=6f479244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f479244",
  null
  
)

export default component.exports